/**
 * Sanitize text by removing unsupported Unicode characters
 * - Zero-width characters (ZWSP, ZWJ, ZWNJ, etc.)
 * - Unicode specials block (U+FFF0–U+FFFF)
 * - Other invisible/problematic characters
 * 
 * References:
 * - https://en.wikipedia.org/wiki/Zero-width_joiner
 * - https://en.wikipedia.org/wiki/Specials_(Unicode_block)
 * 
 * @param {string} text - Text to sanitize
 * @returns {string} - Cleaned text
 */
export function sanitizeDisplayAs(text) {
  if (typeof text !== 'string') return text;
  
  return text
    // For Petscans and others
    .replace(/_/g,' ')
    // Normalize whitespace (multiple spaces/tabs to single space)
    .replace(/\s+/g, ' ')
    
    // Remove zero-width characters
    .replace(/[\u200B-\u200D\uFEFF]/g, '') // ZWSP, ZWNJ, ZWJ, Zero-width no-break space

    // Remove Unicode specials block (U+FFF0–U+FFFF)
    .replace(/[\uFFF0-\uFFFF]/g, '')
    
    // Remove other control characters (except newlines and tabs)
    // eslint-disable-next-line no-control-regex
    .replace(/[\x00-\x08\x0B-\x0C\x0E-\x1F\x7F-\x9F]/g, '')
    
    // Remove soft hyphens
    .replace(/\u00AD/g, '')
    
    // Trim leading/trailing whitespace
    .trim();
}
